module.exports = __webpack_public_path__ + "img/st1.eb461ed0.png";